import { FormHelperText, Grid, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import React from 'react';
import CustomButton from '../../elements/CustomButton';
import InputField from '../../elements/InputField';

const ProductComparisonForm = ({ onSubmit, product }) => {
  const categoryProductRelationFields = product.category_data?.category_details || [];

  return (
    <>
      <Formik
        initialValues={{
          categoryProductRelation: Object.keys(product.category_product_relation || {}).reduce((acc, key) => {
            if (categoryProductRelationFields.includes(key)) {
              acc[key] = product.category_product_relation[key] || '';
            }
            return acc;
          }, {}),
        }}
        onSubmit={async (values) => {
          categoryProductRelationFields.forEach((detail) => {
            const detailKey = `${detail}`;
            if (!values.categoryProductRelation.hasOwnProperty(detailKey)) {
              values.categoryProductRelation[detailKey] = '';
            }
          });
          await onSubmit(values);
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {categoryProductRelationFields.map((detail, index) => (
                <Grid item xs={12} key={index}>
                  <Stack spacing={1}>
                    <InputField
                      label={`${
                        detail.split('_').map((a) => a.charAt(0).toUpperCase() + a.slice(1)).join('')
                      }`}
                      id={`categoryProductRelation.${detail}`}
                      type="text"
                      value={values.categoryProductRelation[detail] || ''}
                      name={`categoryProductRelation.${detail}`}
                      fullWidth
                      placeholder={`Enter ${detail.split('_').map((a) => a.charAt(0).toUpperCase() + a.slice(1)).join('')}`}
                      error={Boolean(
                        touched[`categoryProductRelation.${detail}`] &&
                        errors[`categoryProductRelation.${detail}`]
                      )}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      multiline
                      required
                    />
                  </Stack>
                </Grid>
              ))}
              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}
              <Grid item xs={12}>
                <CustomButton />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ProductComparisonForm;
